import classNames from "classnames";
import "./accordion.css";

export default function Accordion({uniqueId, removeStyle=false, children}){
    return (
        <div className={classNames("accordion", {"accordion-flush": removeStyle})} id={uniqueId}>
            {children}
        </div>
    );
}